import { render } from "./ObPrompt.vue?vue&type=template&id=60261dfc&scoped=true"
import script from "./ObPrompt.vue?vue&type=script&lang=js"
export * from "./ObPrompt.vue?vue&type=script&lang=js"

import "./ObPrompt.vue?vue&type=style&index=0&id=60261dfc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60261dfc"

export default script